import type { BoardObject } from '../../core/interfaces/board-object.interface.js';
import type { LineObject } from './line.interface.js';
import { FALLBACK_STRATEGY_ID } from './strategies/line-path-strategy.interface.js';

/**
 * Type-narrowing guard for line board objects (PRD-F5 §TR1).
 *
 * Cross-slice consumers MUST use this guard instead of inline
 * `obj.type === 'line'` checks (enforced by the `no-cross-slice-import`
 * ESLint rule). This keeps the slice boundary observable and prevents
 * accidental coupling on the literal type discriminator.
 */
export function isLine(obj: BoardObject): obj is LineObject {
  return obj.type === 'line';
}

/**
 * The path strategy a line is drawn with: its stored `pathStrategy`, or the
 * registry's fallback (`'straight'`) for lines that predate PRD-F5. The one
 * place that resolves the unset default — the optionsbar reads it to apply and
 * to highlight the line-form buttons.
 */
export function linePathStrategyOf(line: LineObject): string {
  return line.pathStrategy ?? FALLBACK_STRATEGY_ID;
}
